module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/essentials-end-c3c9a3af87487ca35fa9da1f7a59ec05.png";